<template>
    <CCard class="order-ld-card">
        <CCardHeader>
            <strong>Доставка</strong> <small>Подробности заказа</small>
        </CCardHeader>
        <CCardBody>
            <CTabs variant="tabs" :active-tab="0">
                <CTab title="Карточка" class="pt-1">

                    <CDataTable
                        hover
                        :items="orderUnmodified.items"
                        :fields="fields"
                        class="pt-3">
                        <template #title="data">
                            <td>{{ data.item.service_title }}</td>
                        </template>

                        <template #price="data">
                            <td>{{ data.item.service_price }}</td>
                        </template>

                        <template #quantity="data">
                            <td>{{ data.item.quantity }}</td>
                        </template>

                        <template #refund_for="data">
                            <td>
                                {{ 
                                    data.item && data.item.refund_for && data.item.refund_comment
                                        ? ` За счет ${data.item.refund_for} (${data.item.refund_comment}) - ${data.item.refund_sum}р.`
                                        : ''
                                }}
                            </td>
                        </template>

                        <template #sum="data">
                            <td v-if="data.item.refund_sum">
                                {{ (data.item.price * data.item.quantity) - data.item.refund_sum }} р.
                            </td>
                            <td v-else>
                                {{ data.item.price * data.item.quantity }} р.
                            </td>
                        </template>

                        <template #edit>
                        </template>
                    </CDataTable>
                </CTab>
            </CTabs>
        </CCardBody>

        <OrderLDItemEdit
            :modal="itemEditModal"
            @update="itemUpdate" 
            @cancel="itemCancel" 
        />
    </CCard>
</template>

<script>
    const { formatDate } = require('../../utils/views');
    import OrderLDItemEdit from './OrderLDItemEdit';

    export default {
        name: 'OrderLD',

        components: {
            OrderLDItemEdit,
        },

        props: {
            order: {
                type: Object,
                default: () => ({})
            },
            orderUnmodified: {
                type: Object,
                default: () => ({})
            }
        },

        data() {
            return {
                isAuthorized: false,
                fields: [
                    { key: 'title', label: 'Услуга' },
                    { key: 'price', label: 'Цена услуги' },
                    { key: 'quantity', label: 'Кол-во' },
                    { key: 'refund_for', label: 'Возврат' },
                    { key: 'sum', label: 'Сумма' },
                    { key: 'edit', label: '' }
                ],
                itemEditModal: {
                    item: {},
                    visible: false,
                    emptyItem: {
                        laundry: {},
                        dish: {},
                        modifiers: [],
                        ingredients: [],
                        refund_for: '',
                        refund_comment: '',
                        price: 0,
                        quantity: 1
                    }
                }
            };
        },

        computed: {
        },

        watch: {},

        mounted() {},

        methods: {
            formatDate(date) {
                return formatDate(date);
            },
            itemAdd() {
                this.itemEditModal.item = this.itemEditModal.emptyItem;
                this.itemEditModal.visible = true;
            },
            itemEdit(id) {
                for(let i=0; i < this.order.items.length; i++) {
                    if(this.order.items[i].id === id) {
                        this.itemEditModal.item = JSON.parse(JSON.stringify(this.order.items[i]));
                        this.itemEditModal.visible = true;
                    }
                }
            },
            itemDelete(id) {
                for(let i=0; i < this.order.items.length; i++) {
                    if(this.order.items[i].id === id) {
                        this.order.items.splice(i, 1);
                    }
                }
            },
            itemUpdate() {
                let items = [];
                for(let i=0; i < this.order.items.length; i++) {
                    if(this.order.items[i].id === this.itemEditModal.item.id) {
                        items.push(this.itemEditModal.item);
                    } else {
                        items.push(this.order.items[i]);
                    }
                }
                if(!this.itemEditModal.item.id) {
                    this.itemEditModal.item.id = 'temp-' + this.order.items.length;
                    items.push(this.itemEditModal.item);
                }
                this.order.items = items;
                this.itemCancel();
            },
            itemCancel() {
                this.itemEditModal.item = this.itemEditModal.emptyItem;
                this.itemEditModal.visible = false;
            },
            orderUpdate() {
                for(let i=0; i < this.order.items.length; i++) {
                    if(this.order.items[i].id && this.order.items[i].id.toString().indexOf('temp-') >= 0) {
                        delete this.order.items[i].id;
                    }
                }
                this.$emit('update');
            }
        },
    };
</script>

<style scoped>
.order-ld-card .table th, 
.order-ld-card .table td {
    vertical-align: middle;
}
</style>
